import React from 'react';
import {
  IconAccount,
  IconLock,
  IconBusiness,
  IconDocument,
  IconCheck,
  IconPlay,
  IconInfo,
  IconSuccess,
  IconStatementReady,
  IconP2p,
  IconMembership,
  IconBank,
  IconUnlock,
  IconRefresh,
  IconLocation,
  IconPlus,
  IconTrash,
} from '@americanexpress/dls-icons';

export const getIcon = (iconName, iconProps = {}) => {
  switch (iconName) {
    case 'IconLock':
      return <IconLock {...iconProps} />;
    case 'IconUnlock':
      return <IconUnlock {...iconProps} />;
    case 'IconAccount':
      return <IconAccount {...iconProps} />;
    case 'IconBusiness':
      return <IconBusiness {...iconProps} />;
    case 'IconDocument':
      return <IconDocument {...iconProps} />;
    case 'IconCheck':
      return <IconCheck {...iconProps} />;
    case 'IconPlay':
      return <IconPlay {...iconProps} />;
    case 'IconInfo':
      return <IconInfo {...iconProps} />;
    case 'IconSuccess':
      return <IconSuccess {...iconProps} />;
    case 'IconP2p':
      return <IconP2p {...iconProps} />;
    case 'IconStatementReady':
      return <IconStatementReady {...iconProps} />;
    case 'IconMembership':
      return <IconMembership {...iconProps} />;
    case 'IconBank':
      return <IconBank {...iconProps} />;
    case 'IconRefresh':
      return <IconRefresh {...iconProps} />;
    case 'IconLocation':
      return <IconLocation {...iconProps} />;
    case 'IconPlus':
      return <IconPlus {...iconProps} />;
    case 'IconTrash':
      return <IconTrash {...iconProps} />;
    default:
      return '';
  }
};
